import { useQuery } from "@tanstack/react-query";
import { auditApi } from "./api";
import type { AuditSearchFilters } from "./types";

export function useAuditEvents(filters: AuditSearchFilters, page: number, size = 20) {
  return useQuery({
    queryKey: ["audit-events", filters, page, size],
    queryFn: () => auditApi.search(filters, page, size),
    placeholderData: (prev) => prev,
  });
}
